import AppConfig from "config";
import axios from "axios";
const jwtToken = localStorage.getItem('access_token');

const OperacoesController = {
    async ListOperations() {
        try {
          const response = await axios.get(AppConfig.BACKEND_URL_REFATORADO+`operation_page/operations`, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data.result;
        } catch (error) {
          console.error("Error fetching transcripts:", error);
          throw error;
        }
      },
      async AddOperations(description) {
        try {
          const response = await axios.post(AppConfig.BACKEND_URL_REFATORADO + `operation_page/operations`, {
            description: description
          }, {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
            },
          });
          return response.data;
        } catch (error) {
          console.error("Error creating user:", error);
          throw error;
        }
      },
      async PutOperation(Id, description) {
        try {
          const response = await axios.put(
            `${AppConfig.BACKEND_URL_REFATORADO}operation_page/operations/${Id}`,
            { description },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error updating user:", error);
          throw error;
        }
      },      
      async DeleteOperations(Id) {
        try {
          const response = await axios.delete(
            `${AppConfig.BACKEND_URL_REFATORADO}operation_page/operations/${Id}`,
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          return response.data;
        } catch (error) {
          console.error("Error deleting user:", error);
          throw error;
        }
      },
    };

export default OperacoesController;